module.exports = __webpack_public_path__ + "images/emoji/statue_of_liberty.9e15145f3fe6ea1a7568.png";